import { Link } from 'react-router-dom';
import { appConfig } from "../../apiConfig";

export default function Footer() {
  return (
    <footer className="bg-white text-black" dir="rtl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16 lg:py-20">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Logo and Description */}
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block group">
              <img src={`/images/${appConfig.slug}-logo.png`} height={80} width={appConfig.slug === 'nextlead' ? 150 : 120} alt="logo" />
              </Link>
              <p className="mt-6 text-gray-600  leading-relaxed max-w-md">
                أكثر منصات التسويق بالعمولة موثوقية في العالم. تواصل مع العلامات التجارية المتميزة وحقق أقصى إمكاناتك في الأرباح.
              </p>
              <div className="mt-8 flex space-x-5">
              </div>
            </div>

            <div>
              <h3 className="text-xs max-md:mt-20 font-bold text-black tracking-wider uppercase mb-6">المنصة</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">الرئيسية</Link></li>
                <li><Link to="/about" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">من نحن</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">اتصل بنا</Link></li>
                <li><Link to="/affiliate-program" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">برنامج الشركاء</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xs font-bold text-black tracking-wider uppercase mb-6">الموارد</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/help" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">مركز المساعدة</Link></li>
                <li><Link to="/blog" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">المدونة</Link></li>
                <li><Link to="/tutorials" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">الدروس</Link></li>
                <li><Link to="/case-studies" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">دراسات الحالة</Link></li>
                <li><Link to="/api" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">وثائق API</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xs font-bold text-black tracking-wider uppercase mb-6">القانوني</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/policy" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">سياسة الخصوصية</Link></li>
                <li><Link to="/terms" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">شروط الخدمة</Link></li>
                <li><Link to="/cookies" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">سياسة الكوكيز</Link></li>
                <li><Link to="/gdpr" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">الامتثال للائحة GDPR</Link></li>
                <li><Link to="/affiliate-disclosure" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">إفصاح الشركاء</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar - Remain in English as requested */}
        <div className="border-t border-gray-200 py-8 text-xs" dir="ltr">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <p className="text-gray-600 text-center lg:text-left">
              © {new Date().getFullYear()} {appConfig.name} - All rights reserved
            </p>
            <div className="flex flex-wrap justify-center lg:justify-end space-x-6">
              <Link to="/policy" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">Privacy</Link>
              <Link to="/terms" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">Terms</Link>
              <Link to="/cookies" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">Cookies</Link>
              <Link to="/sitemap" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
